// extracted by mini-css-extract-plugin
module.exports = {"componentHolder":"ItemCategory_componentHolder__2J48a","ListHolder":"ItemCategory_ListHolder__3PTkC","InputHolder":"ItemCategory_InputHolder__1V0eN"};